<script lang="ts">
	import { editable } from '../editable';
	import Blok from '../blok.svelte';
	import type { ISbRichtext, ISbStoryData } from '@storyblok/js';
	import SbRichtext from '../components/sbRichtext.svelte';

	interface Props {
		content: ISbStoryData<{
			asset: ISbStoryData[];
			headline: ISbRichtext;
			text: string;
		}>['content'];
		index?: number;
		size: 'small' | 'regular' | 'large';
	}

	let { content, index, size = 'regular' }: Props = $props();
</script>

<div class="flex-1 text-brown-1" use:editable={content}>
	<div
		class={[
			'relative overflow-hidden',
			size === 'small' ? 'aspect-4/3 rounded-lg' : 'aspect-3/2 rounded-xl'
		]}
	>
		{#if content.asset.length > 0}
			<Blok content={content.asset[0]} />
		{/if}
		{#if index !== undefined}
			<div class="absolute left-0 top-0 flex items-center justify-center p-4">
				<div
					class="h-9 w-9 rounded-full bg-brown-1 text-center font-rhymes text-[24px]/[140%] font-medium tracking-[-.24px] text-white"
				>
					{index + 1}
				</div>
			</div>
		{/if}
	</div>
	{#if content.headline}
		<p
			class="mt-4 text-balance text-[24px]/[108%] tracking-[-.24px] lg:mt-6 lg:text-[28px]/[110%] lg:tracking-[-.28px]"
		>
			<SbRichtext text={content.headline} />
		</p>
	{/if}
	<p
		class={[
			'text-balance lg:max-w-[80%]',
			content.headline ? 'mt-2 text-brown-4' : 'mt-3',
			{
				'text-[16px]/[150%] tracking-[-.16px] lg:text-[14px]/[160%] lg:tracking-[-.14px]':
					size === 'small'
			},
			{
				'text-[16px]/[150%] tracking-[-.16px]': size === 'regular'
			},
			{
				'text-[16px]/[150%] tracking-[-.16px] lg:mt-4 lg:text-[20px]/[140%] lg:tracking-[-.2px]':
					size === 'large'
			}
		]}
	>
		{content.text}
	</p>
</div>
